<template>
  <div
    id="main"
    ref="main"
    @click="$hub.emit('clicked')"
    @mousemove="onMouseMove"
    :class="{'is-full': $route.meta.isFull}"
    class="u-full-width u-relative u-overflow-hidden u-antialiased"
  >
    <symbols-svg />
    <div ref="containerWebGL" class="u-wrapper-panel"/>
    <!-- <router-view v-slot="{ Component }">
      <transition name="t-fader">
        <component :is="Component" />
      </transition>
    </router-view> -->

    <div ref="containerCSS3D" class="u-wrapper-panel u-overflow-hidden"/>
    <img alt="Vue logo" src="./assets/logo.png">
  </div>
</template>

<script>
import { OrbitControls, LoaderManager } from 'shimmer'

import App from './App'

import { webGL } from '@/webGL/WebGL'
import { Environment } from '@/webGL/objects/Environment'
import { Floor } from '@/webGL/objects/Floor'
import { Ball } from '@/webGL/objects/Ball'
import { textureLib } from '@/webGL/TextureLib'

import SymbolsSvg from '@/components/SymbolsSvg'

import {
  AmbientLight,
  SphereGeometry,
  PlaneGeometry,
  MeshNormalMaterial,
  Mesh
} from 'three'

export default {
  name: 'App',

  mixins: [App],

  components: {
    SymbolsSvg
  },

  created () {
    this.pointerevent = null
  },

  mounted () {
    webGL.camera.position.set(0, 10, 20)

    // this.testReflector()
    this.addEnvironment()

    this.controls = new OrbitControls(webGL.camera, this.$refs.main)
    this.controls.enableDamping = true
    this.controls.dampingFactor = 0.1
    this.$refs.main.addEventListener('pointerdown', this.controls.onPointerDown)
    this.$refs.main.addEventListener('pointercancel', this.controls.onPointerCancel)

    this.onResize()
  },

  methods: {
    testReflector () {
      const ambient = new AmbientLight(0xffffff)
      webGL.scene.add(ambient)

      const columns = 10
      const lines = 30
      const marge = 3
      for (let i = 0; i < columns; i++) {
        for (let j = 0; j < lines; j++) {
          const mesh = new Ball()
          mesh.position.x = i * marge - columns * marge * .5 + marge * .5
          mesh.position.z = j * marge - lines * marge * .5 + marge * .5
          webGL.scene.add(mesh)
        }
      }

      const floor = new Floor()
      webGL.scene.add(floor)
    },

    async addEnvironment () {
      this.environment = new Environment('baked')
      webGL.scene.add(this.environment)

      await textureLib.promise
      webGL.scene.environment = textureLib.envMap
    },

    onUpdate (time) {
      if (this.controls) {
        this.controls.update()
      }
      this._onUpdate(time)
    }
  },

  beforeUnmount () {
    if (this.controls) {
      this.controls.dispose()
    }

    this.$refs.main.removeEventListener('pointerdown', this.controls.onPointerDown)
    this.$refs.main.removeEventListener('pointercancel', this.controls.onPointerCancel)
  }
}
</script>

<style lang="stylus" src="./styles/theme.styl"/>

<style lang="stylus">
// @import '~@/styles/settings/variables'

#main
  min-height 100vh

  &.is-full
    position fixed
    top .2px
    bottom .2px
    left 0
    right 0
    overflow hidden
    min-height auto

</style>